<ion-grid class="ion-no-padding ">
    <ion-row class="ion-justify-content-center ion-text-center main-wrapper">
        <ion-col size-xl="6" size-lg="6" size-md="6" size-sm="12" size-xs="12">
            <div #map id="map" class="map stafferMap"></div>
        </ion-col>

    </ion-row>
</ion-grid>